<div *ngIf="loaded" class="login-body">
    <p-toast position="top-center">
    </p-toast>
    <div class="login-panel">
      <div class="grid">
        <div class="col-12">
          <img src="assets/layout/images/logo-login.png" />
          <h1>Erste Anmeldung</h1>
          <h2>{{app.appName}}</h2>
        </div>
        <span *ngIf="app.mainConfig.authRules.useRecoveryQuestions" style="text-align: left;margin-bottom: 20px">
            Sie melden sich gerade das erste Mal an. Bitte vergeben Sie ein neues Passwort und beantworten Sie mindestens {{app.mainConfig.authRules.minRecoveryQuestions}} der untenstehenden Sicherheitsfragen.
        </span>
        <span *ngIf="!app.mainConfig.authRules.useRecoveryQuestions" style="text-align: left;margin-bottom: 20px">
            Sie melden sich gerade das erste Mal an. Bitte vergeben Sie ein neues Passwort.
        </span>
        <span style="text-align: left;margin-bottom: 20px">{{pwText}}</span>
        <sm-form class="width100p" [form]="form">
        </sm-form>
        <div class="col-12">
          <p-button styleClass="width100p" icon="fas fa-sign-in" label="Abschließen" (onClick)="send()">
          </p-button>
          <a [routerLink]="['/base', 'login']">
            <p-button styleClass="width100p" icon="fas fa-lock" label="Abbrechen" (onClick)="cancel()">
            </p-button>
          </a>
          <div *ngIf="running">
            <div>Einrichtung läuft ...</div>
            <p-progressSpinner></p-progressSpinner>

        </div>
      </div>
    </div>
  </div>
